// ============================================================
// DESIGN TOKENS — RealtyFlows Luxury (Navy · Gold · Cream)
// ============================================================
export const tokens = {
  // Backgrounds
  pageBg:      "#FAF8F3",      // cream
  surface:     "#FFFFFF",      // white
  surfaceWarm: "#F2EDE0",      // cream-mid
  navBg:       "#0C1B33",      // navy

  // Navy palette
  navy:        "#0C1B33",
  navyMid:     "#122040",
  navyLight:   "#1A3260",

  // Borders
  border:      "rgba(12,27,51,0.10)",
  borderDark:  "rgba(12,27,51,0.18)",
  borderGold:  "rgba(184,148,58,0.3)",

  // Brand — gold as primary accent
  emerald:     "#B8943A",      // gold (primary accent)
  emeraldLight:"#F9F0D8",      // gold-pale
  emeraldDeep: "#8B6914",      // dark gold
  gold:        "#B8943A",
  goldLight:   "#D4AB52",
  goldPale:    "#F9F0D8",
  amber:       "#D4AB52",      // gold-light
  amberLight:  "#F5E6C0",
  coral:       "#B91C1C",      // red
  coralLight:  "#FEF2F2",      // red-bg
  sky:         "#1D4ED8",      // blue
  skyLight:    "#EFF6FF",
  purple:      "#7c3aed",
  purpleLight: "#f3eeff",
  green:       "#15803D",
  greenBg:     "#F0FDF4",

  // Text
  textPrimary:   "#0C1B33",    // navy
  textSecondary: "#2A3F5E",    // text-mid
  textMuted:     "#7A8BA0",    // text-muted
  textFaint:     "#B0BEC8",
  textNav:       "rgba(255,255,255,0.6)",
  textNavActive: "#D4AB52",    // gold-light

  // Shadows
  shadow:      "rgba(12,27,51,0.08)",
  shadowMd:    "rgba(12,27,51,0.15)",

  // AI glow
  aiGlow:      "rgba(184,148,58,0.12)",

  // Stage kanban tops
  stageOrange: "#f97316",
  stagePurple: "#8b5cf6",
  stageAmber:  "#B8943A",
  stageGreen:  "#15803D",
};

export const fonts = {
  display: "'Cormorant Garamond', Georgia, serif",
  body:    "'Montserrat', sans-serif",
  mono:    "'JetBrains Mono', monospace",
};

// Shorthand aliases
export const t = tokens;
export const font = fonts;
